export default (store) => {
  store.registerModule('editorjs', {
    namespaced: true,
    state: () => ({
      slashPosition: {},
      uploadedImages: [],
    }),
    mutations: {
      setSlashPosition(state, slashPosition) {
        state.slashPosition = { ...state.slashPosition, ...slashPosition };
      },
      pushUploadedImages(state, { image }) {
        state.uploadedImages.push(image);
      },
      setUploadedImages(state, uploadedImages) {
        state.uploadedImages = uploadedImages;
      },
      clearUploadedImages(state) {
        state.uploadedImages = [];
      },
    },
  });
};
